export default __webpack_public_path__ + "static/media/startCharacters.fa70e073.png";